import styled from 'styled-components';

const DatePickerWrapper = styled.div`
  position: relative;
  .datepicker-block {
    width: ${props => props.mainWidth || 'auto'};
  }
  .single-input {
    width: 100%;
    height: ${props => props.inputHeight || 38}px;
    border-radius: 4px;
    border: solid 1px #eaeeef;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    padding: 0 16px;
    &:hover {
      border: solid 1px #7a86a9;
    }
    &.error {
      border-radius: 4px;
      border: solid 1px #f6a4a4;
    }
  }
  .icon {
    content: '';
    position: absolute;
    right: 16px;
    top: ${props => props.iconTop || 10}px;
    cursor: pointer;
  }
  .custom-picker {
    z-index: 95;
    padding: 32px;
    padding-top: 34px;
    display: none;
    position: absolute;
    top: 40px;
    left: 0;
    width: 377px;
    border-radius: 4px;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.08);
    border: solid 1px #eaeeef;
    background-color: #ffffff;
    &.show {
      display: block;
    }
    .datepicker-week-block {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-bottom: 32px;
    }
    .datepicker-months {
      display: flex;
      justify-content: space-between;
      .datepicker-block {
        width: 311px;
        .datepicker-nav {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-content: center;
          margin-bottom: 25px;
          .datepicker-nav-button {
            display: flex;
            background: none;
            color: inherit;
            border: none;
            padding: 0;
            font: inherit;
            cursor: pointer;
            outline: inherit;
            &.hide-nav {
              visibility: hidden;
            }
          }
          .datepicker-month-title {
            align-self: center;
            font-size: 16px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: center;
            color: #24272a;
          }
        }
        .datepicker-week-day {
          font-size: 14px;
          font-weight: 500;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.57;
          letter-spacing: normal;
          text-align: center;
          color: #616674;
          width: 44.4px;
        }
        .datepicker-month-picker {
          width: 60px;
          height: 32px;
        }
        .datepicker-days-block {
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          .datepicker-day {
            background: none;
            border: none;
            padding: 0;
            font: inherit;
            cursor: pointer;
            outline: inherit;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.57;
            letter-spacing: normal;
            text-align: center;
            color: #24272a;
            width: 44.4px;
            height: 32px;
            dispalay: flex;
            &.datepicker-month-picker {
              width: 77px;
              height: 50px;
              &.selected:hover {
                background-color: #bcd87a;
              }
              &:hover {
                background-color: #f7f9fa;
              }
            }
            &.selected {
              border-radius: 4px;
              background-color: #bcd87a;
              &.range {
                background-color: #bcd87a;
              }
            }
            &.range {
              background-color: #f7f9fa;
            }
            &.in-list {
              background-color: #f7f9fa;
            }
            &:disabled,
            &[disabled] {
              opacity: 0.5;
              cursor: default;
            }
          }
        }
      }
    }
    &.range {
      width: 720px;
      &.single {
        width: auto;
      }
    }
  }
`;

export default DatePickerWrapper;
